import { api } from './client';

export interface SessionChain {
  chain_id: string;
  jti: string;
  username: string;
  started_at: number;
  last_seen: number;
  ip: string;
  user_agent: string;
  refresh_count: number;
}

export async function fetchSessions(): Promise<SessionChain[]> {
  const { data } = await api.get<{ sessions: SessionChain[] }>('/auth/sessions');
  return data.sessions;
}

export async function forceLogoutChain(chainId: string): Promise<void> {
  await api.delete(`/auth/sessions/chain/${encodeURIComponent(chainId)}`);
}

export async function forceLogoutUser(username: string): Promise<void> {
  await api.delete(`/auth/sessions/user/${encodeURIComponent(username)}`);
}
